<button type="button"
        class="edit-managing-facility"
        *ngIf="isFacilityDriven"
        (click)="editManagingFacility()"
        [disabled]="disabled"
        [style.cursor]="disabled ? 'not-allowed' : 'pointer'"
        [style.opacity]="disabled ? '0.5' : '1'"
        [ngClass]="customCssClass"
        [ngStyle]="customStyleItem"
        genTooltip [tooltipHtml]="getToolTipText()" [tooltipPosition]="tooltipPosition"
        [appendToBody]="true" [tooltipShow]="true">
  <span [ngClass]="manageFacilityAction?.icon ? manageFacilityAction.icon : 'icon__HospitalLocation'"></span>
</button>
